import type { ReactElement } from "react"
import type { Typography } from "@onestore/hel/dist/contexts/TypographyContext"
import type Theme from "@onestore/hel/dist/typings/theme"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import type { Components } from "react-markdown"
import BaseMarkdown from "../Base"

interface Props {
  children: string
  components?: Components
  typography?: Typography
  boldTypography?: Typography
  emphasis?: Theme.Emphasis
  hasNotPushSpace?: boolean
  alignment?: "left" | "center" | "right"
}

function Title({
  children,
  components,
  typography,
  boldTypography,
  emphasis,
  hasNotPushSpace,
  alignment,
}: Props): ReactElement<Props> {
  const baseMarkdownOverrides = getBaseMarkdownOverrides({
    typography: typography || "xhuge",
    boldTypography: boldTypography,
    emphasis: emphasis,
    pushSpace: hasNotPushSpace ? undefined : 1,
    alignment: alignment,
  })

  return (
    <BaseMarkdown components={components || baseMarkdownOverrides}>
      {children}
    </BaseMarkdown>
  )
}

export default Title
